<template>
  <v-card class="publication-card">
    <v-card-title class="publication-card__title">
      <div>
        {{ item.title }}
      </div>
    </v-card-title>
    <v-card-subtitle class="py-2">
      <div class="publication-card__url">
        <a v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer">
          {{ item.url }}
        </a>
        <a v-if="item.media_url" :href="item.media_url" target="_blank" rel="noopener noreferrer">
          {{ item.media_url }}
        </a>
      </div>
      <div class="publication-card__publish-date">
        <div>Источник: {{ item.source_name }}</div>
        <div>Дата: {{ $moment(item.publish_date).format('D MMM Y, HH:mm:ss') }}</div>
        <div>Поступление: {{ $moment(item.created).format('D MMM Y, HH:mm:ss') }}</div>
      </div>
    </v-card-subtitle>
    <v-card-text>
      <div v-if="summary" class="publication-card__text" v-html="item.summary"></div>
      <div v-else class="publication-card__text" v-html="item.text"></div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    'item': {
      type: Object,
      default: () => null,
    },
    'summary': {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    page() {
      return this.item.page
    },
  },
}
</script>

<style scoped lang="scss">
.publication-card {
  &__publish-date {
    font-weight: bold;
  }
  &__author {
    font-weight: bold;
  }
  &__text {
    white-space: pre-wrap;
    word-wrap: break-word;
    text-align: justify;
  }
}
</style>
